import * as React from 'react'
import callResourceAndDispatchActions from '../callResourceAndDispatchActions'
import get from 'lodash.get'
import resetResource from '../resetResource'
import { AppContext } from '../../context/appContext'
import { appLocalStorage, getApiCallSequenceSteps as types } from '../../utils/misc'
import {
  contractSendUrlPost,
  eDocSignProviderEContractCreatePost,
  eDocSignProviderEContractGet
} from '../../lib/contract'
import { EDOCSIGNPROVIDER_TEMPLATE_ID, LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME } from '../../utils/constants'
import { getToken } from '../../utils/auth'

const SELECTED_COMPANY_ID = get(
  appLocalStorage.getValue(LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME),
  'selectedCompany.id',
  ''
)

export const useContractSendUrlPost = () => {
  const { dispatch } = React.useContext(AppContext)
  const RESOURCE_NAME_FOR_ACTIONS = 'CONTRACT_SEND_URL_POST'
  const dispatchApiCallActions = (data: any, id?: string) =>
    callResourceAndDispatchActions(contractSendUrlPost, {
      data,
      dispatch,
      id: SELECTED_COMPANY_ID || id,
      token: getToken(),
      types: { ...types(RESOURCE_NAME_FOR_ACTIONS) }
    })
  const dispatchResetAction = () => resetResource(dispatch, { ...types(RESOURCE_NAME_FOR_ACTIONS) })
  return {
    contractSendUrlPost: dispatchApiCallActions,
    contractSendUrlPostReset: dispatchResetAction
  }
}

export const useEDocSignProviderEContractGet = () => {
  const { dispatch } = React.useContext(AppContext)
  const RESOURCE_NAME_FOR_ACTIONS = 'EDOCSIGNPROVIDER_ECONTRACT_GET'
  const dispatchApiCallActions = (id: string) =>
    callResourceAndDispatchActions(eDocSignProviderEContractGet, {
      dispatch,
      id,
      token: getToken(),
      types: { ...types(RESOURCE_NAME_FOR_ACTIONS) }
    })
  const dispatchResetAction = () => resetResource(dispatch, { ...types(RESOURCE_NAME_FOR_ACTIONS) })
  return {
    eDocSignProviderEContractGet: dispatchApiCallActions,
    eDocSignProviderEContractGetReset: dispatchResetAction
  }
}

export const useEDocSignProviderEContractCreatePost = () => {
  const { dispatch } = React.useContext(AppContext)
  const RESOURCE_NAME_FOR_ACTIONS = 'EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST'
  const dispatchApiCallActions = (data: any) =>
    callResourceAndDispatchActions(eDocSignProviderEContractCreatePost, {
      data,
      dispatch,
      id: EDOCSIGNPROVIDER_TEMPLATE_ID,
      token: getToken(),
      types: { ...types(RESOURCE_NAME_FOR_ACTIONS) }
    })
  const dispatchResetAction = () => resetResource(dispatch, { ...types(RESOURCE_NAME_FOR_ACTIONS) })
  return {
    eDocSignProviderEContractCreatePost: dispatchApiCallActions,
    eDocSignProviderEContractCreatePostReset: dispatchResetAction
  }
}
